var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRawMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rawMaterial") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FD\\u5E73-\\u4EA7\\u54C1\\u78B3\\u8DB3\\u8FF9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6289-\\u7B2C\\u4E09\\u6B65-LCA-\\u7ED3\\u679C",
    transform: "translate(-182.000000, -2354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rawMaterial",
    transform: "translate(183.000000, 2354.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2 L13,2 C13.2761424,2 13.5,2.22385763 13.5,2.5 L13.5,3 C13.5,3.27614237 13.2761424,3.5 13,3.5 L1,3.5 C0.723857625,3.5 0.5,3.27614237 0.5,3 L0.5,2.5 C0.5,2.22385763 0.723857625,2 1,2 Z M21.75,20.5 L23.5,20.5 C23.7761424,20.5 24,20.7238576 24,21 L24,21.5 C24,21.7761424 23.7761424,22 23.5,22 L0.5,22 C0.223857625,22 0,21.7761424 0,21.5 L0,21 C0,20.7238576 0.223857625,20.5 0.5,20.5 L11.75,20.5 L11.75,20.5 M13.5,4.5 L23,4.5 C23.2761424,4.5 23.5,4.72385763 23.5,5 L23.5,5.5 C23.5,5.77614237 23.2761424,6 23,6 L13.5,6 C13.2238576,6 13,5.77614237 13,5.5 L13,5 C13,4.72385763 13.2238576,4.5 13.5,4.5 Z M0.25,8.25 L13.25,8.25 M12.75,10.25 L23.5,10.25 M12.75,15.25 L23.5,15.25 M0.25,14.25 L13.25,14.25 M1,3.5 L1,20.25 M12.75,3.75 L12.75,19.25 M22.75,5.75 L22.75,20.25",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#979797",
    strokeWidth: 0.6,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,12.25 C14.2071068,12.25 14.3946068,12.3339466 14.5303301,12.4696699 C14.6660534,12.6053932 14.75,12.7928932 14.75,13 L14.75,17.2775781 L10.6402069,21.75 L6,21.75 C5.79289322,21.75 5.60539322,21.6660534 5.46966991,21.5303301 C5.33394661,21.3946068 5.25,21.2071068 5.25,21 L5.25,13 C5.25,12.7928932 5.33394661,12.6053932 5.46966991,12.4696699 C5.60539322,12.3339466 5.79289322,12.25 6,12.25 Z",
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#59D744"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    strokeWidth: 0.5,
    x: 9.25,
    y: 12.25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    stroke: "#979797",
    strokeWidth: 0.5,
    x: 6.75,
    y: 18.75,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,22 C13.3333333,18.4166667 15.4166667,16.625 16.75,16.625 C18.0833333,16.625 20.1666667,18.4166667 23,22 L10.5,22 Z",
    id: "\\u8DEF\\u5F84-6",
    stroke: "#979797",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75,18 C17.8880712,18 18,18.1119288 18,18.25 C18,18.3880712 17.8880712,18.5 17.75,18.5 L16.25,18.5 C16.1119288,18.5 16,18.3880712 16,18.25 C16,18.1119288 16.1119288,18 16.25,18 L17.75,18 Z",
    id: "\\u8DEF\\u5F84-7",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,20.25 C19.1380712,20.25 19.25,20.3619288 19.25,20.5 C19.25,20.6380712 19.1380712,20.75 19,20.75 L17.25,20.75 C17.1119288,20.75 17,20.6380712 17,20.5 C17,20.3619288 17.1119288,20.25 17.25,20.25 L19,20.25 Z",
    id: "\\u8DEF\\u5F84-7\\u5907\\u4EFD",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,19.25 C16.6380712,19.25 16.75,19.3619288 16.75,19.5 C16.75,19.6380712 16.6380712,19.75 16.5,19.75 L14.75,19.75 C14.6119288,19.75 14.5,19.6380712 14.5,19.5 C14.5,19.3619288 14.6119288,19.25 14.75,19.25 L16.5,19.25 Z",
    id: "\\u8DEF\\u5F84-7\\u5907\\u4EFD-2",
    fill: "#979797",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawMaterial);
export default __webpack_public_path__ + "static/media/rawMaterial.365f94150df01f564ae29c6fa1950fd4.svg";
export { ForwardRef as ReactComponent };